import React from 'react';

const Error = () => <div className="error">Page Not Found!</div>;

export default Error;
